import { AfterViewInit, Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import flatpickr from 'flatpickr';
import { RatesService } from 'src/app/api/hospitality/rates.service';
declare var $: any;

@Component({
  selector: 'app-rates-form',
  templateUrl: './rates-form.component.html',
  styleUrls: ['./rates-form.component.css']
})
export class RatesFormComponent implements OnInit, AfterViewInit {
  branchofficeSlug: string = '';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  // variables
  roomtypes: any;
  flatpickrStart: any;
  flatpickrEnd: any;
  detail_ranges: any = [];

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    private ratesService: RatesService,
    private route: ActivatedRoute,
    private alertifyMsg: AlertifyHelper,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.route.snapshot.params['id'];
    this.item = this.fb.group({
      description: ['', [Validators.required, Validators.minLength(2)]],
      abbreviation: [null],
      start_date: [null],
      end_date: [null],
      is_show: [true]
    });

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;
    }
  }

  ngOnInit() {
    this.navigationTrackerService.initializeMenu(this.route);
    if (this.isEdit) {
      this.editData();
    }
  }

  ngAfterViewInit(): void {
    this.flatpickrStart = flatpickr('#start_date', {
      altInput: true,
      altFormat: 'd-m-Y',
      dateFormat: 'Y-m-d',
      enableTime: false
    });

    this.flatpickrEnd = flatpickr('#end_date', {
      altInput: true,
      altFormat: 'd-m-Y',
      dateFormat: 'Y-m-d',
      enableTime: false
    });
  }

  editData() {
    this.ratesService.get(this.checkId).subscribe({
      next: (data: any) => {
        let item_ = data.data;
        this.item.patchValue({
          description: item_.description,
          abbreviation: item_.abbreviation,
          start_date: item_.start_date,
          end_date: item_.end_date,
          is_show: item_.is_show
        });

        this.detail_ranges = item_.ranges_rate;
        setTimeout(() => {
          if (this.detail_ranges.length > 0) {
            for (let i in this.detail_ranges) {
              this.setDateflatpickr(i);
            }
          }
        }, 150);

        // if (this.flatpickrStart) {
        //   this.flatpickrStart.setDate(item_.start_date, true, 'Y-m-d');
        // }
        // if (this.flatpickrEnd) {
        //   this.flatpickrEnd.setDate(item_.end_date, true, 'Y-m-d');
        // }
      }
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  addRangeRate() {
    let obj_: any = {};
    obj_.id = null;
    obj_.description = null;
    obj_.start_date = null;
    obj_.end_date = null;
    this.detail_ranges.push(obj_);

    setTimeout(() => {
      let last_index = this.detail_ranges.length - 1;
      this.setDateflatpickr(last_index);
    }, 250);
  }

  setDateflatpickr(index: any) {
    this.flatpickrStart = flatpickr('#start_date' + index, {
      altInput: true,
      altFormat: 'd-m-Y',
      dateFormat: 'Y-m-d',
      enableTime: false
    });

    this.flatpickrEnd = flatpickr('#end_date' + index, {
      altInput: true,
      altFormat: 'd-m-Y',
      dateFormat: 'Y-m-d',
      enableTime: false
    });
  }

  changeDescription(param: any, index: number): void {
    let value_ = param.value;
    this.detail_ranges[index].description = value_;
  }

  changeStarDate(param: any, index: number): void {
    let value_ = param.value;
    this.detail_ranges[index].start_date = value_;
  }

  changeEndDate(param: any, index: number): void {
    let value_ = param.value;
    this.detail_ranges[index].end_date = value_;
  }

  removeRangeRate(id: any, index: any) {
    this.detail_ranges.splice(index, 1);
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }

    let data: any = {};
    data.item = this.item.value;
    data.detail_ranges = this.detail_ranges;

    if (this.validate()) {
      if (this.isEdit) {
        this.ratesService.update(this.checkId, data).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro actualizado con éxito');
            this.cancel();
          }
        });
      } else {
        this.ratesService.save(data).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro realizado con éxito');
            this.cancel();
          }
        });
      }
    }
  }

  validate() {
    if (this.detail_ranges.length > 0) {
      for (let i in this.detail_ranges) {
        let item_ = this.detail_ranges[i];
        let index_ = Number(i)+1;
        if (_.isNull(item_.start_date)) {
          (<any>$('#start_date' + i)).focus();
          this.alertifyMsg.warning(
            'Depe especificar la fecha de Inicio para el rango de la fila '+index_
          );
          return false;
        }
        if (_.isNull(item_.end_date)) {
          (<any>$('#end_date' + i)).focus();
          this.alertifyMsg.warning(
            'Depe especificar la fecha de Fin para el rango de la fila '+index_
          );
          return false;
        }
      }
    }

    return true;
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/hoteleria/tarifas/lista']);
  }
}
